import React, { Component } from 'react';
import { Auth } from '../../../../services/api';
import { Form, Alert } from 'antd';
import ResetForm from './Form';

const WrappedForm = Form.create()(ResetForm)

export default class Reset extends Component {
    constructor(props) {
        super(props);

        this.authApi = new Auth();

        this.state = {
            success: false,
            loading: false
        };
    }

    reset = (email) => {
        this.setState({ loading: true });
        this.authApi.reset(email)
            .then(res => {
                this.setState({ success: true, loading: false });
            })
            .catch(err => {
                this.setState({ loading: false });
            });
    };

    render() {
        const { loading, success } = this.state;

        return (
            <div>
                {success && (
                    <Alert
                        style={{marginBottom: '20px'}}
                        description="Instruktioner för återställing av lösenord har skickats till din epost."
                        type="success"
                    />
                )}
                <WrappedForm loading={loading} submitHandler={this.reset} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/auth/components/reset/Reset.js